const urls = {
    START_EDIT: 'movement-instruction/start-edit',
    SUMMARY: 'movement-instruction/summary',
    HEADER: 'movement-instruction/header',
    LOT: 'movement-instruction/lot',
    LOT_ANALYSIS_SAMPLE: 'movement-instruction/analysis-sample',
    LOT_BOL_HEADER: 'movement-instruction/bol-header',
    LOT_BOL_ITEM: 'movement-instruction/bol-item',
    LOT_DOCUMENT: 'movement-instruction/lot-document',
    LOT_DOCUMENT_RECEIVER: 'movement-instruction/lot-document-receiver',
    LOT_PRODUCT_SPECIFICATION: 'movement-instruction/lot-product-specification',
    LOT_UOM: 'movement-instruction/lot-uom',
    LOG: 'movement-instruction/change-logs',
    STATUSES: 'movement-instruction/status',
    ETA: 'movement-instruction/eta',
    CHECK_IS_FIP: 'movement-instruction/lot-check-is-fip',

    CLONE_LOT: 'movement-instruction/clone-lot',
    COPY_LOT: 'movement-instruction/copy-lot',
    // FISCAL_INFORMATION_RULES_VISIBLE_CHECK: 'movement-instruction/fiscal-information-rules-visible-check',

    PREVIOUS_VERSION: 'audit/movement-instruction',
    REVERT: 'movement-instruction/revert',
    PRINT_TELEX: 'movement-instruction/print',
    CLONE: 'movement-instruction/clone',
    SUMMARY_COMPLETE: 'movement-instruction/summary-complete',

    CONFIG_IS_OUT_CDEP: 'movement-instruction-outcdep-configuration/is-out-cdep',

    PRODUCT_SPECIFICATION_NOTE: 'masterdata/product-specification-note',
    PRODUCT_SPECIFICATION_NOTE_COMBO: 'masterdata/product-specification-note-combo',
    PRODUCT_SPECIFICATION_HEADER_DETAILS: 'product-specification-header-details',
    PRODUCT_SPECIFICATION_HEADER_DETAILS_EXCEPTION: 'lot-product-specification-exception',
    PRODUCT_SPECIFICATION_DETAIL_NOTE: 'masterdata/product-specification-detail-note',
    PRODUCT_SPECIFICATION_HEADER_PRINT: 'masterdata/product-specification-header-print',
    MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE: 'movement-instruction-save-as-favorite',
    MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE_CLONE: 'movement-instruction-save-as-favorite-clone',

    USER_ROLE_OPERATION_TYPE_COMBO : 'movement-instruction/user-role-operation-type-combo',


    VESSEL_PROTOCOL_DISCHARGE_TRACKING_BY_LOT_ID: 'vessel-protocol-discharge-tracking-by-movement-instruction-lot-id',
    WEEKLY_SETTLEMENT_GET_PRODUCT_QUANTITY: 'movement-instruction/get-product-quantity',
    WEEKLY_SETTLEMENT_GET_TRANSFER_STOCK: 'movement-instruction/get-transfer-stock',
    WEEKLY_SETTLEMENT_IMPORT_TRANSFER_STOCK: 'movement-instruction/import-transfer-stock',
    WEEKLY_SETTLEMENT_CHECK_TRANSFER_STOCK: 'movement-instruction/check-transfer-stock',
    WEEKLY_SETTLEMENT_IMPORT_SELECTED_TRANSFER_STOCK: 'movement-instruction/import-selected-transfer-stock',

    VESSEL_NOMINATION: 'movement-instruction/vessel-nomination',
    VESSEL_NOMINATION_LINK: 'movement-instruction/vessel-nomination/link',
    VESSEL_NOMINATION_DELTA: 'movement-instruction/vessel-nomination/delta',
    LOT_DOCUMENT_WITH_RECEIVER: 'movement-instruction/lot-document-with-receivers',

    VESSEL_ACCEPTANCE_GET_ACCEPTED_VESSEL_LIST: 'movement-instruction/vessel-acceptance-get-accepted-vessel-list',

    SITE_CONTRACTS: 'movement-instruction/site-contract',
    SITE_CONTRACTS_CREATE: 'movement-instruction/site-contract-create',
    SITE_CONTRACTS_CLONE: 'movement-instruction/site-contract-clone',
    SITE_CONTRACTS_SEND: 'movement-instruction/site-contract-send',
    SITE_CONTRACTS_OPERATIONS: 'movement-instruction/site-contract-operations',
}

import genericService from '../genericService';

export default {

    async startEdit(body, callback){
        await genericService.putOnlyId(urls.START_EDIT, body).then(callback);
    },
    async getSummary(body, callback){
        await genericService.getItem(urls.SUMMARY, body).then(callback);
    },
    // async checkFiscalInformationVisibility(body, callback){
    //     await genericService.get(urls.FISCAL_INFORMATION_RULES_VISIBLE_CHECK, body).then(callback);
    // },
    async getLog (body, callback){
        await genericService.get(urls.LOG, body).then(callback);
    },
    async getHeader (body, callback){
        await genericService.getItem(urls.HEADER, body).then(callback);
    },
    async saveHeader(body, callback){
        await genericService.put(urls.HEADER, body).then(callback);
    },
    async createHeader(body, callback){
        await genericService.post(urls.HEADER, body).then(callback);
    },
    async getLot (id, callback){
        await genericService.getItem(urls.LOT, id).then(callback);
    },
    async createLot(body, callback){
        await genericService.post(urls.LOT, body).then(callback);
    },
    async saveLotMain(body, callback){
        await genericService.put(urls.LOT, body).then(callback);
    },
    async deleteLot(id, callback){
        await genericService.delete(urls.LOT, id).then(callback);
    },
    async getLots (body, callback){
        await genericService.get(urls.LOT, body).then(callback);
    },
    async getLotBoLHeaders (body, callback){
        await genericService.get(urls.LOT_BOL_HEADER, body).then(callback);
    },
    async createLotBoLHeader(body, callback){
        await genericService.post(urls.LOT_BOL_HEADER, body).then(callback);
    },
    async updateLotBoLHeader(body, callback){
        await genericService.put(urls.LOT_BOL_HEADER, body).then(callback);
    },
    async deleteLotBoLHeader(id, callback){
        await genericService.delete(urls.LOT_BOL_HEADER, id).then(callback);
    },
    async getLotBoLItems (body, callback){
        await genericService.get(urls.LOT_BOL_ITEM, body).then(callback);
    },
    async createLotBoLItem (body, callback){
        await genericService.post(urls.LOT_BOL_ITEM, body).then(callback);
    },
    async updateLotBoLItem (body, callback){
        await genericService.put(urls.LOT_BOL_ITEM, body).then(callback);
    },
    async deleteLotBoItem(id, callback){
        await genericService.delete(urls.LOT_BOL_ITEM, id).then(callback);
    },
    async getMeasureUnits(body, callback){
        await genericService.get(urls.LOT_UOM, body).then(callback);
    },
    async createMeasureUnit (body, callback){
        await genericService.post(urls.LOT_UOM, body).then(callback);
    },
    async updateMeasureUnit (body, callback){
        await genericService.put(urls.LOT_UOM, body).then(callback);
    },
    async deleteMeasureUnit(id, callback){
        await genericService.delete(urls.LOT_UOM, id).then(callback);
    },
    async getProductSpecs(body, callback){
        await genericService.get(urls.LOT_PRODUCT_SPECIFICATION, body).then(callback);
    },
    async createProductSpec (body, callback){
        await genericService.post(urls.LOT_PRODUCT_SPECIFICATION, body).then(callback);
    },
    async updateProductSpec (body, callback){
        await genericService.put(urls.LOT_PRODUCT_SPECIFICATION, body).then(callback);
    },
    async deleteProductSpec(id, callback){
        await genericService.delete(urls.LOT_PRODUCT_SPECIFICATION, id).then(callback);
    },
    async getAnalysisSample(body, callback){
        await genericService.get(urls.LOT_ANALYSIS_SAMPLE, body).then(callback);
    },
    async createAnalysisSample (body, callback){
        await genericService.post(urls.LOT_ANALYSIS_SAMPLE, body).then(callback);
    },
    async updateAnalysisSample (body, callback){
        await genericService.put(urls.LOT_ANALYSIS_SAMPLE, body).then(callback);
    },
    async deleteAnalysisSample(id, callback){
        await genericService.delete(urls.LOT_ANALYSIS_SAMPLE, id).then(callback);
    },
    async getDocuments(body, callback){
        await genericService.get(urls.LOT_DOCUMENT, body).then(callback);
    },
    async createDocument (body, callback){
        await genericService.post(urls.LOT_DOCUMENT, body).then(callback);
    },
    async updateDocument (body, callback){
        await genericService.put(urls.LOT_DOCUMENT, body).then(callback);
    },
    async deleteDocument(id, callback){
        await genericService.delete(urls.LOT_DOCUMENT, id).then(callback);
    },
    async getDocumentReceivers(body, callback){
        await genericService.get(urls.LOT_DOCUMENT_RECEIVER, body).then(callback);
    },
    async createDocumentReceiver (body, callback){
        await genericService.post(urls.LOT_DOCUMENT_RECEIVER, body).then(callback);
    },
    async updateDocumentReceiver (body, callback){
        await genericService.put(urls.LOT_DOCUMENT_RECEIVER, body).then(callback);
    },
    async deleteDocumentReceiver(id, callback){
        await genericService.delete(urls.LOT_DOCUMENT_RECEIVER, id).then(callback);
    },
    async cloneLot (body, callback){
        await genericService.post(urls.CLONE_LOT, body).then(callback);
    },
    async copyLot (body, callback){
        await genericService.post(urls.COPY_LOT, body).then(callback);
    },
    async getEta(body, callback){
        await genericService.get(urls.ETA, body).then(callback);
    },
    async createEta (body, callback){
        await genericService.post(urls.ETA, body).then(callback);
    },
    async updateEta (body, callback){
        await genericService.put(urls.ETA, body).then(callback);
    },
    async deleteEta(id, callback){
        await genericService.delete(urls.ETA, id).then(callback);
    },
    async previousVersion(body, callback){
        await genericService.get(urls.PREVIOUS_VERSION, body).then(callback);
    },
    async printMovementInstruction(body, callback){
        await genericService.dowloadFile(urls.PRINT_TELEX, body).then(callback);
    },
    async revertMovementInstruction(body, callback){
        await genericService.putOnlyId(urls.REVERT, body, 'versionId').then(callback);
    },
    async cloneMovmentIstruction(body, callback){
        await genericService.put(urls.CLONE, body, "headerId").then(callback);
    },
    async deleteMovementInstruction(id, callback){
        await genericService.delete(urls.HEADER, id).then(callback);
    },
    async getSummaryComplete(body, callback){
        await genericService.getItem(urls.SUMMARY_COMPLETE, body).then(callback);
    },
    async configIsOutCDep(body, callback){
        await genericService.post(urls.CONFIG_IS_OUT_CDEP, body).then(callback);
    },
    async getProductSpecsNote(body, callback) {
        await genericService.get(urls.PRODUCT_SPECIFICATION_NOTE, body).then(callback);
    },
    async getProductSpecsNoteCombo(body, callback) {
        await genericService.getItem(urls.PRODUCT_SPECIFICATION_NOTE_COMBO, body).then(callback);
    },
    async productSpecHeaderDetails(body, callback) {
        await genericService.get(urls.PRODUCT_SPECIFICATION_HEADER_DETAILS, body).then(callback);
    },
    async addProductSpecHeaderDetailsException(body, callback) {
        await genericService.post(urls.PRODUCT_SPECIFICATION_HEADER_DETAILS_EXCEPTION, body).then(callback);
    },
    async updateProductSpecHeaderDetailsException(body, callback) {
        await genericService.put(urls.PRODUCT_SPECIFICATION_HEADER_DETAILS_EXCEPTION, body).then(callback);
    },
    async getProductSpecDetailNote(body, callback) {
        await genericService.getItem(urls.PRODUCT_SPECIFICATION_DETAIL_NOTE, body).then(callback);
    },
    async printProductSpecHeader(body, callback) {
        await genericService.dowloadFile(urls.PRODUCT_SPECIFICATION_HEADER_PRINT, body).then(callback);
    },
    async saveAsFavourite(body, callback) {
        await genericService.post(urls.MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE, body).then(callback);
    },
    async getAllSavedAsFavourites (body, callback){
        await genericService.get(urls.MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE, body).then(callback);
    },
    async isMovementInstructionSavedAsFavourite(body, callback) {
        await genericService.getItem(urls.MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE, body).then(callback);
    },
    async saveAsFavouriteClone(body, callback) {
        await genericService.post(urls.MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE_CLONE, body).then(callback);
    },
    async removeFromFavourites(id, callback) {
        await genericService.delete(urls.MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE, id).then(callback);
    },
    async updateFavourite (body, callback){
        await genericService.put(urls.MOVEMENT_INSTRUCTION_SAVE_AS_FAVOURITE, body).then(callback);
    },
    async getUserRoleOperationTypeCombo(callback){
        await genericService.get(urls.USER_ROLE_OPERATION_TYPE_COMBO, {}).then(callback);
    },
    async getVesselProtocolDischargeTrackingByLotId(body, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_DISCHARGE_TRACKING_BY_LOT_ID, body).then(callback);
    },
    async checkIsFip(body, callback){
        await genericService.get(urls.CHECK_IS_FIP, body).then(callback);
    },
    async getProductQuantity(body,callback){
        await genericService.get(urls.WEEKLY_SETTLEMENT_GET_PRODUCT_QUANTITY, body).then(callback);
    },
    async getTransferStock(body,callback){
        await genericService.get(urls.WEEKLY_SETTLEMENT_GET_TRANSFER_STOCK, body).then(callback);
    },
    async importTransferStock(body,callback){
        await genericService.post(urls.WEEKLY_SETTLEMENT_IMPORT_TRANSFER_STOCK, body).then(callback);
    },
    async checkTransferStock(body,callback){
        await genericService.get(urls.WEEKLY_SETTLEMENT_CHECK_TRANSFER_STOCK, body).then(callback);
    },
    async importSelectedTransferStock(body,callback){
        await genericService.post(urls.WEEKLY_SETTLEMENT_IMPORT_SELECTED_TRANSFER_STOCK, body).then(callback);
    },
    async getVesselNomination(body,callback){
        await genericService.get(urls.VESSEL_NOMINATION, body).then(callback);
    },
    async getVesselNominationById(id,callback){
        await genericService.getItem(urls.VESSEL_NOMINATION, id).then(callback);
    },
    async vesselNominationLink(body,callback){
        await genericService.post(urls.VESSEL_NOMINATION_LINK, body).then(callback);
    },
    async vesselNominationUnlink(id,callback){
        await genericService.delete(urls.VESSEL_NOMINATION_LINK, id).then(callback);
    },
    async vesselNominationParcelLink(body,callback){
        await genericService.put(urls.VESSEL_NOMINATION_LINK, body, 'topicId').then(callback);
    },
    async getVesselNominationDelta(voyageNumber,callback){
        await genericService.getItem(urls.VESSEL_NOMINATION_DELTA, voyageNumber).then(callback);
    },
    async saveLotDocumentWithReceivers(body,callback){
        await genericService.post(urls.LOT_DOCUMENT_WITH_RECEIVER, body).then(callback);
    },
    async getAcceptedVesselList(body,callback){
        await genericService.get(urls.VESSEL_ACCEPTANCE_GET_ACCEPTED_VESSEL_LIST, body).then(callback);
    },
    async getSiteContracts(body,callback){
        await genericService.get(urls.SITE_CONTRACTS, body).then(callback);
    },
    async updateSiteContracts(body,callback){
        await genericService.put(urls.SITE_CONTRACTS, body).then(callback);
    },
    async deleteSiteContracts(id,callback){
        await genericService.delete(urls.SITE_CONTRACTS, id).then(callback);
    },
    async addSiteContracts(body,callback){
        await genericService.post(urls.SITE_CONTRACTS, body).then(callback);
    },
    async createSiteContracts(body,callback){
        await genericService.post(urls.SITE_CONTRACTS_CREATE, body).then(callback);
    },
    async cloneSiteContracts(body,callback){
        await genericService.post(urls.SITE_CONTRACTS_CLONE, body).then(callback);
    },
    async sendSiteContracts(body,callback){
        await genericService.post(urls.SITE_CONTRACTS_SEND, body).then(callback);
    },
    async addSiteContractOperation(body,callback){
        await genericService.post(urls.SITE_CONTRACTS_OPERATIONS, body).then(callback);
    }
}